import HealthSafety from './healthSafety';
import Whmis from './whmis';
import './index.scss';

export default {
  HealthSafety,
  Whmis
};
